import { isBoolean } from 'lodash';
import React from 'react';
import { getControlStyle } from '../helper';

export function NumberDecimal(props) {
  const { placeHolder, rowIndex, colIndex, charCount, maxCount, onChange, CustomAddEditAccess, textColour, otherConfiguration, isProductArchived } = props;
  const combinedStyles = getControlStyle(otherConfiguration);
  const limitNumberLength = (event) => {
    const inputValue = event.target.value.toString();

    if (inputValue.length > maxCount) {
      event.preventDefault(); // Prevent further input
    } else {
      onChange(event.target.value, rowIndex, colIndex);
    }
  };
  return (
    <div className="input-group form-floating-label-po p-0 mb-0 fixed-label">
      <label />
      <input
        type="number"
        placeholder={placeHolder}
        className={`form-control ${textColour || ''}`}
        value={props?.value || ''}
        disabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
        autoComplete="off"
        style={combinedStyles}
        maxLength={maxCount}
        onChange={limitNumberLength}
      />

      {charCount && (
        <div className="text-count">
          {props?.value?.length || 0}/{maxCount}
        </div>
      )}
    </div>
  );
}
export default NumberDecimal;
